export default {
    sinCertificado: "sinCertificado",
    certificadoExp: "certificadoExp",
    sinNumeracion: "sinNumeracion",
    paqueteExp: 'paqueteExp',
    sinComprobantes: 'sinComprobantes',
}


